import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { CareerPlan, CareerPlanSkill, CompletedCareerPlans } from 'src/app/models/career-plans';
import { CareerPlansApiService } from 'src/app/services/api/career-plans-api.service';
import { CareerPlansService } from 'src/app/services/career-plans.service';
import { ConfigService } from 'src/app/services/config.service';
import { ResizeService } from 'src/app/services/resize.service';

@Component({
  selector: 'app-career-plans',
  templateUrl: './career-plans.component.html',
  styleUrls: ['./career-plans.component.scss'],
})
export class CareerPlansComponent implements OnInit {
  careerPlan: CareerPlan;
  skillRows: CareerPlanSkill[][] = [];

  careerPlanHistory$: Observable<CompletedCareerPlans>;
  section = 'career-plans';

  showCareerPlanPositions = false;
  careerPlanLoaded = false;
  completedHistoryLabel: string = 'careerPlans.history.completed';
  titleLabel: string = 'careerPlans.title';

  constructor(
    private resizeService: ResizeService,
    private careerPlansApiService: CareerPlansApiService,
    private configService: ConfigService,
    private router: Router,
    private careerPlansService: CareerPlansService
  ) {
    if (!this.configService.get().showCareerPlanFeatures) {
      this.router.navigate(['/user/checkouts']);
    }
  }

  ngOnInit() {
    this.careerPlansApiService
      .getCurrentCareerPlan()
      .subscribe((careerPlanResponse) => {
        this.careerPlan = careerPlanResponse;
        this.skillRows = this.careerPlansService.updateSkillRows(
          this.resizeService.getCurrentScreenBreakpoint(),
          this.careerPlan,
          this.skillRows
        );
        this.careerPlanLoaded = true;
      });

    this.resizeService
      .getDeviceChangeObs()
      .subscribe(
        (bp) => (this.skillRows = this.careerPlansService.updateSkillRows(bp, this.careerPlan, this.skillRows))
      );

    this.careerPlanHistory$ = this.careerPlansApiService.getCareerPlanHistory();
    this.showCareerPlanPositions = this.configService.get()?.showCareerPlanPositions;
  }
}
